import type { RecoveryConfig } from 'api/recoveryAi.types'

// Single source of truth for the two RecoveryAI lifecycle predicates the
// activation money-safety guards ride on. Landing's dashboard gate, the Wizard's
// re-entry guard (never downgrade a live full_auto agent — AI-580), and
// ConfiguredSummary's onboarding entry guard all derive from these, so keeping
// them in one place stops the invariant from silently drifting apart.
type StatusConfig = Pick<
  RecoveryConfig,
  'onboarding_completed' | 'operating_mode'
>

// Configured = the wizard's Finalize has flipped onboarding_completed. Until then
// the merchant sees GetStarted, not the live dashboard or the activate CTA.
export const isRecoveryConfigured = (config?: Partial<StatusConfig>): boolean =>
  !!config?.onboarding_completed

// Active = configured AND operating_mode is a known running mode. Explicit
// allow-list (not `!== 'off'`) so a null/unknown mode fails closed, and gated on
// configured so a half-finished wizard never reads as active.
export const isRecoveryActive = (config?: Partial<StatusConfig>): boolean =>
  isRecoveryConfigured(config) &&
  (config?.operating_mode === 'full_auto' ||
    config?.operating_mode === 'feedback_only')
